import React from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
  } else {
    return <Navigate to="/login" replace />;
  }

  return children;
}
